var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"file",attrs:{"type":"file","name":"file-input","accept":_vm.accept,"id":"file-input"},on:{"change":_vm.handleFileChange}}),_c('label',{attrs:{"for":"file-input"}},[_vm._v("ファイルを選択")])])}
var staticRenderFns = []

export { render, staticRenderFns }